import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'QUICK_SEARCH';

export const {action: show} = createAction(`${domain}/SHOW`, () => ({}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
